<template>
    <div class="device iphone-x" v-if="myValue">
      <!--    外部轮廓    -->
      <div class="frame">
        <div class="content">
          <div class="phone-body">
            <iframe :src="'https://exshow-web.cbebaiwen.com/applet/#' + myUrl" frameborder="0"></iframe>
          </div>
        </div>
      </div>

      <!--    天线    -->
      <div class="stripe"></div>

      <!--    听筒孔    -->
      <div class="header">
        <div class="sensors"></div>
      </div>

      <!--    按键    -->
      <div class="btns"></div>
      <div class="power"></div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseURl: this.baseUrl,
      myValue: this.value,
      flag: 0,
      tips: false,
      timer: null,
      myUrl: this.src
    }
  },
  watch: {
    value (val) {
      this.myValue = val
    },
    src (val) {
      this.myUrl = val
    }
  },
  created () {},
  mounted () {},
  methods: {
  }
}
</script>

<style lang="less" scoped>
.device *,
.device *::before,
.device *::after {
  box-sizing: border-box;
  display: block;
}

.device {
  margin: 50px auto;
  position: relative;
}

.device .frame {
  z-index: 1;
}

.iphone-x {
  height: 810px;
  width: 400px;
}

.iphone-x .frame {
  background: #222;
  border-radius: 54px;
  box-shadow: inset 0 0 0 2px #606467, inset 0 0 0 6px #e2e3e4;
  height: 810px;
  padding: 22px;
  width: 400px;
}

.iphone-x .content {
  background-color: #fff;
  background-position: center center;
  background-size: cover;
  border-radius: 32px;
  height: 766px;
  position: relative;
  width: 358px;
  box-sizing: border-box;
  padding: 26px 4px 15px 4px;
  overflow: auto;
}

.iphone-x .stripe::after,
.iphone-x .stripe::before {
  border: solid rgba(51, 51, 51, 0.25);
  border-width: 0 6px;
  content: "";
  height: 5px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 9;
}

.iphone-x .stripe::after {
  top: 68px;
}

.iphone-x .stripe::before {
  bottom: 68px;
}
.iphone-x .header {
  background: #222;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  height: 24px;
  left: 50%;
  margin-left: -82px;
  position: absolute;
  top: 22px;
  width: 164px;
  z-index: 199;
}

.iphone-x .header::after,
.iphone-x .header::before {
  content: "";
  height: 6px;
  position: absolute;
  top: 0;
  width: 6px;
}

.iphone-x .header::after {
  background: radial-gradient(
    circle at bottom left,
    transparent 0,
    transparent 75%,
    #222 75%,
    #222 100%
  );
  left: -6px;
}

.iphone-x .header::before {
  background: radial-gradient(
    circle at bottom right,
    transparent 0,
    transparent 75%,
    #222 75%,
    #222 100%
  );
  right: -6px;
}

.iphone-x .sensors::after,
.iphone-x .sensors::before {
  content: "";
  position: absolute;
}

.iphone-x .sensors::after {
  background: #444;
  border-radius: 2.5px;
  height: 5px;
  left: 50%;
  margin-left: -20px;
  top: 4px;
  width: 40px;
}

.iphone-x .sensors::before {
  background: #444;
  border-radius: 50%;
  height: 11px;
  left: 50%;
  margin-left: 30px;
  top: 1px;
  width: 11px;
}
.iphone-x .btns {
  background: #606467;
  height: 26px;
  left: -2px;
  position: absolute;
  top: 92px;
  width: 3px;
}

.iphone-x .btns::after,
.iphone-x .btns::before {
  background: #606467;
  content: "";
  height: 50px;
  left: 0;
  position: absolute;
  width: 3px;
}

.iphone-x .btns::after {
  top: 48px;
}

.iphone-x .btns::before {
  top: 112px;
}

.iphone-x .power {
  background: #606467;
  height: 80px;
  position: absolute;
  right: -2px;
  top: 160px;
  width: 3px;
}

// 滚动条
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}

::-webkit-scrollbar-thumb {
  height: 0 !important;
}

.phone-body {
  width: 100%;
  height: 100%;
  overflow: auto;
  iframe {
    width: 100%;
    height: 100%;
  }
}
.phone-content {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/iphonex.vue